var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"el-icon-refresh",on:{"click":_vm.refreshRoute}})
}
var staticRenderFns = []

export { render, staticRenderFns }